import React from "react";
import {
  Divider,
  MenuItem,
  TextField,
  Stack,
  Typography,
  Checkbox,
  Paper,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// COMPONENTS
import { FormFieldWrapper } from "../components/FormFieldWrapper";
import { StyledInput } from "../components/StyledInput";

// import { DateField } from '@mui/x-date-pickers/DateField';
import { stateOptions } from "./FormData";

// import Divider from '@mui/material/Divider';
import useWindowDimensions from "../hooks/useWindowDimensions";
import { useAuthContext } from "../context/AuthContext";
import FormSectionHeader from "../components/FormSectionHeader";

import "./ApplicantForm.css";
import "../App.css";

const ApplicantForm = ({
  formik,
  searchPrice,
  prices,
  brands,
  handleSubmit,
  paymentInProgress,
}) => {
  const { width: displayWidth, mobileVersion } = useWindowDimensions();
  const { isAuthenticated, user } = useAuthContext();

  // Add this function to handle form submission and scrolling
  const handleFormSubmit = () => {
    if (Object.keys(formik.errors).length > 0) {
      // Get the first field with an error
      const firstErrorField = Object.keys(formik.errors)[0];

      // Find the element with that field name
      const errorElement = document.querySelector(
        `[name="${firstErrorField}"]`
      );

      if (errorElement) {
        // Scroll the element into view with smooth behavior
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        // Optional: focus the field
        errorElement.focus();
      }
    }

    handleSubmit();
  };

  return (
    <Stack
      direction="column"
      spacing={3}
      sx={{
        width: "100%",
        justifyContent: "flex-start",
        alignItems: "flex-start",
      }}
      role="form"
      aria-label="Applicant Form"
    >
      {prices && (
        <>
          <FormSectionHeader title="Your authority to access scheme records" />
          <StyledInput
            name={"statusToRecords"}
            label={"I am a..."}
            formData={formik}
            options={prices[formik.values.state]}
            width={"100%"}
            ariaLabel="Status to Records"
            ariaRequired="true"
          />
        </>
      )}

      {(formik.values.statusToRecords === "agent_appointed_by_the_requestor" ||
        formik.values.statusToRecords ===
          "another_person_with_a_proper_interest_in_the_information_sought" ||
        formik.values.statusToRecords === "prospective_lot_buyer") && (
        <Stack
          direction="column"
          spacing={3}
          sx={{
            width: "100%",
            justifyContent: "flex-start",
            alignItems: "flex-start",
          }}
          role="region"
          aria-label="Authorization Documents Section"
        >
          {formik.values.statusToRecords === "prospective_lot_buyer" ? (
            formik.values.state === "NSW" ? (
              <Typography align="left" variant="body1">
                Please attach a letter of approval from the seller's agent that
                shows they allow you to inspect the record. The letter must
                include a date and clearly show the owner's name and signature.
                The application will not be considered without this written
                permission.
              </Typography>
            ) : (
              <Typography>
                Please complete a "Form 12 - Requiring information from a body
                corporate" form and attach it below. A "Form 12" can be
                downloaded from the Queensland Government website or by clicking{" "}
                <a
                  href="https://www.publications.qld.gov.au/ckan-publications-attachments-prod/resources/e65c4fc6-c43e-4738-953e-a53930716b82/bccm-form-12-v10b.pdf?ETag=ccdac78b949f248ecb99d7eff6ed0695"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  here
                </a>
              </Typography>
            )
          ) : (
            <>
              <Typography align="left" variant="body1">
                As the agent or another person with proper interest in the
                information, you are required to provide written authority from
                the party you are representing.
              </Typography>
              <Typography variant="body1">
                Please attach signed letter of authority.
              </Typography>
            </>
          )}

          <TextField
            fullWidth
            id={"files"}
            name={"files"}
            type="file"
            onChange={(event) => {
              const files = event.target.files;
              let myFiles = Array.from(files);
              formik.setFieldValue("files", myFiles);
            }}
            onBlur={formik.handleBlur}
            error={formik.touched["files"] && Boolean(formik.errors["files"])}
            helperText={formik.touched["files"] && formik.errors["files"]}
            size={"small"}
            inputProps={{
              "aria-label": "Authorization Document Upload",
              "aria-required": "true",
              style: { cursor: "pointer" },
            }}
            sx={{
              "& .MuiInputBase-root": {
                backgroundColor: "white",
              },
              "& .MuiFormHelperText-root": {
                backgroundColor: "transparent",
              },
            }}
          />

          {/* {formik.values.statusToRecords === "agent_appointed_by_the_requestor" && (
                            <>
                                <FormSectionHeader title="Applicant's agent details" description="The following person can act as an agent in conducting inspection of scheme records." /> 

                                <StyledInput name={'agencyName'} label={'Agency name'} formData={formik} width={mobileVersion ? '100%' : '50%'} ariaLabel="Agency name" ariaRequired="true" />

                                <Stack direction={mobileVersion ? "column" : "row"} spacing={2} sx={{ width: "100%", justifyContent: "space-between" }}>
                                    <StyledInput name={'agentFirstName'} label={'First name'} formData={formik} width={mobileVersion ? '100%' : '45%'} ariaLabel="Agent first name" ariaRequired="true" />
                                    <StyledInput name={'agentLastName'} label={'Last name'} formData={formik} width={mobileVersion ? '100%' : '45%'} ariaLabel="Agent last name" ariaRequired="true" />
                                </Stack>

                                <Stack direction={mobileVersion ? "column" : "row"} spacing={2} sx={{ width: "100%", justifyContent: "space-between" }}>
                                    <StyledInput name={'agentEmail'} label={'Email'} formData={formik} width={mobileVersion ? '100%' : '45%'} ariaLabel="Agent email" ariaRequired="true" />
                                    <StyledInput name={'agentContactNumber'} label={'Contact number'} formData={formik} width={mobileVersion ? '100%' : '45%'} ariaLabel="Agent contact number" ariaRequired="true" />
                                </Stack>
                            </>
                        )} */}
        </Stack>
      )}

      {/*********************************************  APPLICANTS DETAILS *********************************************/}
      <FormSectionHeader
        title="Your details"
        description="Please provide your information for billing and communication purposes."
      />

      {formik.values.statusToRecords === "agent_appointed_by_the_requestor" && (
        <StyledInput
          name={"agencyName"}
          label={"Agency name"}
          formData={formik}
          width={mobileVersion ? "100%" : "50%"}
          ariaLabel="Agency name"
          ariaRequired="true"
        />
      )}

      <Stack
        direction={mobileVersion ? "column" : "row"}
        spacing={2}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <StyledInput
          name={"firstName"}
          label={"First name"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="First name"
          ariaRequired="true"
        />
        <StyledInput
          name={"lastName"}
          label={"Last name"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Last name"
          ariaRequired="true"
        />
      </Stack>

      <Stack
        direction={mobileVersion ? "column" : "row"}
        spacing={2}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <StyledInput
          name={"email"}
          label={"Email"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Email"
          ariaRequired="true"
        />
        <StyledInput
          name={"contactNumber"}
          label={"Contact number"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Contact number"
          ariaRequired="true"
        />
      </Stack>

      {/*********************************************  PROPERTY DETAILS *********************************************/}
      <FormSectionHeader
        title="Property details"
        description="Please provide the property details for the scheme records you would like to inspect."
      />

      <StyledInput
        name={"address"}
        label={"Address of property"}
        formData={formik}
        width={"100%"}
        ariaLabel="Property address"
        ariaRequired="true"
      />

      <Stack
        direction={mobileVersion ? "column" : "row"}
        spacing={2}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <StyledInput
          name={"suburb"}
          label={"Suburb"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Suburb"
          ariaRequired="true"
        />
        <StyledInput
          name={"postcode"}
          label={"Postcode"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Postcode"
          ariaRequired="true"
        />
      </Stack>

      <Stack
        direction={mobileVersion ? "column" : "row"}
        spacing={0}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <StyledInput
          name={"state"}
          label={"State"}
          formData={formik}
          options={stateOptions}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="State"
          ariaRequired="true"
        />
        <StyledInput
          name={"country"}
          label={"Country"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Country"
          ariaRequired="true"
        />
      </Stack>

      <Stack
        direction={mobileVersion ? "column" : "row"}
        spacing={0}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        <StyledInput
          name={"dpNumber"}
          label={"Scheme number"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Scheme number"
          ariaRequired="true"
        />
        <StyledInput
          name={"lotNumber"}
          label={"Lot number"}
          formData={formik}
          width={mobileVersion ? "100%" : "45%"}
          ariaLabel="Lot number"
          ariaRequired="true"
        />
      </Stack>

      <FormSectionHeader title="Branch" />
      <StyledInput
        name={"brand"}
        label={`The ${formik.values.state} branch that manages the property you are requesting records for`}
        formData={formik}
        options={
          formik.values.state === "NSW"
            ? brands.nswBrandOptions
            : brands.qldBrandOptions
        }
        width={mobileVersion ? "100%" : "70%"}
        ariaLabel="Brand"
        ariaRequired="true"
      />

      <FormSectionHeader title="Inspection duration" />

      <Typography variant="body1">
        When your inspection access is ready, you will be sent an email with a
        link to begin your online inspection session at any time convenient to
        you.
      </Typography>

      <Typography variant="body1">
        There’s no rush — the link in your email won’t expire. But remember,
        once started, your session runs continuously and can’t be paused or
        resumed later. Please ensure you’re ready to use the full amount of time
        you’ve purchased once you begin.
      </Typography>

      <Stack
        direction="row"
        spacing={2}
        sx={{ width: "100%", justifyContent: "space-between" }}
      >
        {/* <FormFieldWrapper label={'Date'} width={'45%'}>
                    <DateField
                        id={'date'}
                        name={'date'}
                        value={formik.values.date}
                        onChange={(newValue) => formik.setFieldValue("date", newValue)}
                        onBlur={formik.handleBlur}
                        error={formik.touched['date'] && Boolean(formik.errors['date'])}
                        helperText={formik.touched['date'] && formik.errors['date']}
                        size={"small"}
                        inputProps={{
                            'aria-label': 'Search Date',
                            'aria-required': 'true'
                        }}
                        sx={{
                            width: '100%',
                            '& .MuiInputBase-root': {
                                backgroundColor: 'white',
                            },
                            '& .MuiFormHelperText-root': {
                                backgroundColor: 'transparent',
                            }
                        }}
                    />
                </FormFieldWrapper> */}

        <StyledInput
          name={"hours"}
          label={"Hours"}
          formData={formik}
          options={
            formik.values.state === "NSW"
              ? [
                  { value: 1, label: "1" },
                  { value: 1.5, label: "1.5" },
                  { value: 2, label: "2" },
                  { value: 2.5, label: "2.5" },
                  { value: 3, label: "3" },
                ]
              : [{ value: 2, label: "2" }]
          }
          width={"45%"}
          ariaLabel="Search Hours"
          ariaRequired="true"
        />
      </Stack>

      <FormSectionHeader title="Search cost" />
      {searchPrice ? (
        <>
          <Typography align="left" variant="body1">
            {formik.values.state} search cost. Price{" "}
            {formik.values.state === "NSW" ? "includes" : "excludes"} GST.
          </Typography>
          <Typography align="left" variant="h6">
            Price: $ {searchPrice}
          </Typography>
        </>
      ) : (
        <Typography align="left" variant="body1">
          Please select the relevant state and the applicant's status to scheme
          records to view the associated costs. Once you've done this, you'll be
          able to see the acknowledgement and acceptance information.
        </Typography>
      )}

      <FormSectionHeader title="Acknowledgment and acceptance" />

      {formik.values.state === "QLD" ? (
        <Typography variant="body1">
          As the party completing the search of the scheme records, I confirm I
          have read all sections of this application. By clicking 'read and
          accepted' below, I agree that I am aware of the requirements and
          regulation modules under the{" "}
          <a
            href="https://www.legislation.qld.gov.au/view/html/inforce/current/act-1997-028"
            target="_blank"
            rel="noopener noreferrer"
          >
            Body Corporate and Community Management Act 1997 – S.205
          </a>
          ,{" "}
          <a
            href="https://www.legislation.qld.gov.au/view/html/asmade/sl-2020-0233"
            target="_blank"
            rel="noopener noreferrer"
          >
            Body Corporate and Community Management (Standard Module) Regulation
            2020 – S.233
          </a>
          , and all other applicable laws relating to the search, access, and
          use of information from the scheme records.
        </Typography>
      ) : (
        <Typography variant="body1">
          As the party completing the search of the scheme records, I confirm I
          have read all sections of this application. By clicking 'read and
          accepted' below, I agree that I am aware of the requirements and
          regulation modules under the{" "}
          <a
            href="https://legislation.nsw.gov.au/view/whole/html/inforce/current/act-2015-050"
            target="_blank"
            rel="noopener noreferrer"
          >
            Strata Schemes Management Act 2015
          </a>
          ,{" "}
          <a
            href="https://legislation.nsw.gov.au/view/html/inforce/current/sl-2016-0501"
            target="_blank"
            rel="noopener noreferrer"
          >
            Strata Schemes Management Regulations 2016 – Schedule 4
          </a>
          , and all other applicable laws relating to the search, access, and
          use of information from the scheme records.
        </Typography>
      )}

      <Stack
        direction="row"
        spacing={2}
        sx={{
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
      >
        <Checkbox
          checked={formik.values.readAndAccepted}
          onChange={formik.handleChange}
          name="readAndAccepted"
          sx={{
            color:
              formik.touched["readAndAccepted"] &&
              Boolean(formik.errors["readAndAccepted"])
                ? "red"
                : null,
          }}
          inputProps={{
            "aria-label": "Accept Terms and Conditions",
            "aria-required": "true",
          }}
        />
        <Typography
          variant="body1"
          onClick={() =>
            formik.setFieldValue(
              "readAndAccepted",
              !formik.values.readAndAccepted
            )
          }
          sx={{
            color:
              formik.touched["readAndAccepted"] &&
              Boolean(formik.errors["readAndAccepted"])
                ? "red"
                : null,
            cursor: "pointer",
            userSelect: "none", // Prevents text selection when clicking
          }}
        >
          I agree to the terms and conditions{" "}
          <span className="form_required">*</span>
        </Typography>
      </Stack>

      <LoadingButton
        color="secondary"
        variant="contained"
        fullWidth={mobileVersion}
        onClick={handleFormSubmit}
        loading={paymentInProgress}
        sx={{
          color: "white",
          minHeight: "36.5px",
        }}
        aria-label="Submit Application"
      >
        {isAuthenticated ? "CREATE ACCESS TOKEN" : "Proceed"}
      </LoadingButton>
    </Stack>
  );
};

export default ApplicantForm;
